import api from './index'
import type { EmailValidationResult } from '@/types'

const EMAILOVERSIGHT_URL = 'https://api.emailoversight.com/api/emailvalidation'
const API_TOKEN = '62689d38-3ee9-4e5f-9f95-756fcc64f377'
const LIST_ID = '44420'

const VALID_TYPES = [
  'Verified',
  'Role',
  'Unknown',
  'Catch All',
  'Complainer',
  'Disposable Email',
  'Suppressed',
]

const AC_INVALID_TYPES = [
  'Unknown',
  'Catch All',
  'Complainer',
  'Disposable Email',
  'Suppressed',
  'Bot',
  'Undeliverable',
  'Malformed',
  'SpamTrap',
]

export async function validateEmail(email: string): Promise<EmailValidationResult> {
  try {
    const response = await api.get(EMAILOVERSIGHT_URL, {
      params: {
        apitoken: API_TOKEN,
        listid: LIST_ID,
        email,
      },
      timeout: 3000,
    })

    const resultType = response.data?.Result || 'Unknown'
    const isValid = VALID_TYPES.includes(resultType)
    const sendToAC = !AC_INVALID_TYPES.includes(resultType)

    return { isValid, sendToAC, resultType }
  } catch (error) {
    // On timeout/error, allow through but flag for logging
    console.error('Email validation error:', error)
    return { isValid: true, sendToAC: true, resultType: 'ERROR' }
  }
}
